// src/QuestionMessage.tsx
import React from "react";
import { makeStyles, tokens } from '@fluentui/react-components';
import { Bubble } from "../ds";
import { getBrandConfig } from '../brands/brand-registry';

// Constants for better maintainability
const QUESTION_LAYOUT = {
  desktop: { paddingLeft: '40%', maxWidth: '60%' },
  tablet: { paddingLeft: '30%', maxWidth: '70%' },
  mobile: { paddingLeft: '30%', maxWidth: '70%' }
} as const;

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'flex-end', // Always right-align
    marginBottom: tokens.spacingVerticalS,
    paddingLeft: QUESTION_LAYOUT.desktop.paddingLeft,
    maxWidth: QUESTION_LAYOUT.desktop.maxWidth,
    width: '100%',
    paddingTop: tokens.spacingVerticalS,
    '@media (max-width: 600px)': {
      paddingLeft: QUESTION_LAYOUT.mobile.paddingLeft,
      maxWidth: QUESTION_LAYOUT.mobile.maxWidth,
      marginBottom: tokens.spacingVerticalXXS,
      paddingTop: tokens.spacingVerticalXXS,
      paddingRight: tokens.spacingHorizontalS,
      justifyContent: 'flex-end', // Explicit right alignment on mobile
    }
  }
});

interface Props {
  question: string;
  domId: string;
}

export const QuestionMessage: React.FC<Props> = ({ question, domId }) => {
  const styles = useStyles();
  const brandConfig = getBrandConfig();
  const questionId = `question-${domId}`;
  const labelId = `question-label-${questionId}`;
  
  return (
    <div className={styles.container}>
      <Bubble 
        kind="user"
        aria-labelledby={`${labelId} ${questionId}`}
      >
        {/* Hidden label for screen reader context */}
        <span id={labelId} className="sr-only">
          {brandConfig.messages.userMessageLabel || 'Your question'}: 
        </span>
        <span id={questionId}>{question}</span>
      </Bubble>
    </div>
  );
};
